export class StdInputData {
    additionalThicknessId: string;
    boltDimensionId: string;
    boltMaterialId: string;
    clampId: string;
    clampMaterialId: string;
    flangeFacingTypeId: string;
    flangeMaterialId1: string;
    flangeMaterialId2: string;
    flangeTypeId1: string;
    flangeTypeId2: string;
    gasketId: string;
    hubMaterialId: string;
    nutDimensionId: string;
    pipeScheduleId: string;
    pipeSizeId: string;
    pressureClassId: string;
    sealRingId: string;
    sealRingMaterialId: string;
    selectedToolId: string;
    standardId: string;

    threadType: string;
    tighteningSpecification: string;
    tighteningSpecificationInput: string;
    washerThickness: string;
    loadLossMethod: string;
    boltType: number;
    boltQuantity: number;

    customStandardName: string;
    customPipeSizeName: string;
    customPipeScheduleName: string;
    reducedAreaBolting: string;
    isRedAreaBoltSelected: boolean;

    additionalThickness: string;
    recommendedGasketStress: string;
    maximumGasketStress: string;
    minimumGasketStress: string;
    minimumBoltDiameter: string;
    y: string;
    m: string;
    pAdditional: number;
    isDataValid: boolean;
    boltMaterialAliasId?: string;
    flangeMaterialAliasId1?: string;
    flangeMaterialAliasId2?: string;
    gasketAliasId?:string;

}
